import PropTypes from "prop-types"
import { Table } from "@mui/material"
import ContributorsTableContent from "components/contributors-table-content"
import { sortData } from "helpers/contributorsSort"
import { VIEW_TYPES } from "helpers/base"
import ContributorsTableGroupHead from "components/contributors-table-group-head"

function DailyDetails({ viewType, disabled, data, show, factorTable, openFactorProfile, groupSort, groupOrder }) {
  return <Table>
    <ContributorsTableGroupHead {...{
      tooltipText: "% Performance",
      groupOrder,
      groupSort,
      label: `% Perf. (${viewType === VIEW_TYPES.ABSOLUTE ? "Absolute" : "Active"})`,
    }}
    />
    <ContributorsTableContent
      factors
      openFactorProfile={openFactorProfile}
      data={sortData(data, groupOrder)}
      show={show}
      disabled={disabled}
      factorTable={factorTable}
    />
  </Table>
}

DailyDetails.propTypes = {
  viewType: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  data: PropTypes.array.isRequired,
  factorTable: PropTypes.bool.isRequired,
  openFactorProfile: PropTypes.func.isRequired,
  show: PropTypes.func.isRequired,
  groupSort: PropTypes.func.isRequired,
  groupOrder: PropTypes.object.isRequired,
}

export default DailyDetails
